import Ko from "./Ko";
export default Ko;
